import React, { Component } from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { Dropdown } from "primereact/dropdown";
import { ConfirmationModal } from "../../template/ConfirmationModal";
import ProductService from "../../services/ProductService";
import tableRequest from "../../models/tableRequest.js";
import CategoryService from "../../services/CategoryService";
import MessageComponent from "../../template/Message";
import { confirmAlert } from "react-confirm-alert";
import { Calendar } from 'primereact/calendar';
import UploaderFileService from "../../services/UploaderFileService"
import "react-confirm-alert/src/react-confirm-alert.css";
import $ from "jquery";
import CompanyMasterService from "../../services/CompanyMasterService";
import { TabView, TabPanel } from 'primereact/tabview';
import ApiService from '../../services/apiService';
import Loaders from '../../template/Loaders';

var allData = []
var minDate = new Date();

export default class ProductMaster extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.ApiService = new ApiService();
    this.CompanyMasterService = new CompanyMasterService();
    this.ProductService = new ProductService();
    this.CategoryService = new CategoryService();
    this.tblResponse = new tableRequest();
    this.UploaderFileService = new UploaderFileService();
    let today = new Date();
    this.invalidDates = [today];
    
    this.state = {
      visible: false,
      visible1: false,
      prodDes: true,
      updateLoader: false,
      formIsValid: true,
      CompId: "",
      ProductId: "",
      ProductName: "",
      ProductCd: "",
      ProductDsrcptn: "",
      ProductImg: "",
      GTIN: "",
      PackOF: "",
      ProductUrl1: "",
      GenuineAudio: "",
      ProductUOM: "",
      activeIndex: 0,
      ProductValue: "",
      CategoryId: null,
      IsActive: false,
      sortOrder: "",
      items: "",
      Product: "",
      ManufactureName: "",
      RegistrationNo: "",
      CautionarySymbol: "",
      AntidoteStatement: "",
      MarketedBy: "",
      ExpDate: '',
      CustomerCareDetails: "",
      WarrantyPeriodInMonth: "",
      formError: {
        ProductName: null,
        Product: null,
        ProductCd: null,
        ProductDsrcptn: null,
        CategoryId: null,
        ExpDate: null,
        ProductImg: null,
        GenuineAudio: null,
        ProductUOM: null,
        ProductValue: null,
        WarrantyPeriodInMonth: null,
        uploadImageLabel: null,
        uploadImagePamphlet: null,
        SapProductCd: null,
        CompanyId: null
      },
      uploadFilePath: "",
      uploadImagPath: "",
      uploadImagDescPath: "",
      uploadImagDescAntiPath: "",
      uploadAudioPath: "",
      uploadImageLabel: "",
      uploadImagePamphlet: "",
      SapProductCd: "",
      TechnicalName: "",
      confirm: false,
      formHeading: "Add Product",
      buttonLabel: "Submit",
      sales: [],
      companyDDL: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
      CategoryDDL: [],
      compDisabled: false,
      checkerror: true,
      refreshLoading: false // Add state for refresh button loading
    };
    
    this.items = [
      {
        label: "Step 1",
        command: (event) => {
          this.activeIndex = 0;
        },
      },
      {
        label: "Step 2",
        command: (event) => {
          this.activeIndex = 1;
        },
      },
      {
        label: "Step 3",
        command: (event) => {
          this.activeIndex = 2;
        },
      },
    ];
    
    this.brandTemplate = this.brandTemplate.bind(this);
    this.brandDescTemplate = this.brandDescTemplate.bind(this);
    this.brandDescAntiTemplate = this.brandDescAntiTemplate.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.actionTemplate1 = this.actionTemplate1.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitDescForm = this.submitDescForm.bind(this);
    this.deleteFunc = this.deleteFunc.bind(this);
    this.setImagePath = this.setImagePath.bind(this);
    this.setFilePath = this.setFilePath.bind(this);
    this.setImageDescPath = this.setImageDescPath.bind(this);
    this.setImageDescAntiPath = this.setImageDescAntiPath.bind(this);
    this.setLabel = this.setLabel.bind(this);
    this.setPamphlet = this.setPamphlet.bind(this);
    this.hideFunc = this.hideFunc.bind(this);
    this.hideFunc1 = this.hideFunc1.bind(this);
    this.setAudioPath = this.setAudioPath.bind(this);
    this.myUploader = this.myUploader.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.openDialog1 = this.openDialog1.bind(this);
    this.onSort = this.onSort.bind(this);
    this.refreshSAPData = this.refreshSAPData.bind(this); // Bind refresh function
  }

  // Function to refresh SAP data
  refreshSAPData() {
    this.setState({ refreshLoading: true });
    
    // Show confirmation dialog before refreshing
    confirmAlert({
      title: 'Confirm Refresh',
      message: 'Are you sure you want to refresh product data from SAP? This may take a few moments.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.ProductService.insertproductsapdata()
              .then((data) => {
                const resdata = data.data;
                this.setState({ refreshLoading: false });
                
                if (resdata !== null && resdata.ResponseCode === "200") {
                  this.refs.Messchild.showSuccess(resdata.ResponseMessage || "Product data refreshed successfully from SAP!");
                  // Refresh the product list after successful refresh
                  this.GetProducts();
                } else if (resdata !== null && resdata.ResponseCode === "400") {
                  this.refs.Messchild.showWarn(resdata.ResponseMessage || "Failed to refresh product data");
                } else {
                  this.refs.Messchild.showError(resdata.ResponseMessage || "Error refreshing product data");
                }
              })
              .catch((error) => {
                this.setState({ refreshLoading: false });
                console.error("Error refreshing SAP data:", error);
                this.refs.Messchild.showError("An error occurred while refreshing product data from SAP");
              });
          }
        },
        {
          label: 'No',
          onClick: () => {
            this.setState({ refreshLoading: false });
          }
        }
      ]
    });
  }

  myUploader(event, t) {
    const fileExt = event.files[0].name.split('.').pop();
    let formData = new FormData();
    let fileToUpload = event.files[0];
    formData.append("file", fileToUpload);
    
    if (fileExt == 'xls' || fileExt == 'xlsx') {
      this.setState({ updateLoader: false });
      this.ProductService.ProductCSVUpload(formData).then(data => {
        const response = data.data;
        this.setState({ updateLoader: true });
        
        if (response.ResponseCode == "200") {
          this.refs.Messchild.showSuccess(response.ResponseMessage);
          this.fileInput.current.clear();
          this.GetProducts();
        }
        else if (response.ResponseCode != "200") {
          this.refs.Messchild.showError(response.ResponseMessage);
          this.fileInput.current.clear();
        }
      });
    } else {
      this.refs.child.showWarn('File extension are not acceptable.');
      this.setState({ updateLoader: true });
    }
  }

  handleChange1(event) {
    const { name, value } = event.target;
    let errors = this.state.formError;
    const isValid = this.validateForm1(value, name);
    this.setState({ errors, [name]: value });
    
    if (name == "IsActive") {
      this.setState({
        IsActive: event.target.checked,
      });
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    let errors = this.state.formError;
    const isValid = this.validateForm(value, name);
    this.setState({ errors, [name]: value });
    
    if (!isValid) {
      this.setState({ activeIndex: 0 });
      this.setState({ prodDes: true });
    }
    
    if (name == "IsActive") {
      this.setState({
        IsActive: event.target.checked,
      });
    }
  }

  getCurrentDate(dt) {
    var today = new Date(dt);
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    
    today = mm + '/' + dd + '/' + yyyy;
    return today;
  }

  brandTemplate(rowData, column) {
    var src = rowData.ProductImg;
    return <img src={src} width="100" alt={rowData.ProductImg} />;
  }

  brandDescTemplate(rowData, column) {
    var src = rowData.CautionarySymbol;
    return <img src={src} width="100" alt={rowData.CautionarySymbol} />;
  }

  brandDescAntiTemplate(rowData, column) {
    var src = rowData.AntidoteStatement;
    return <img src={src} width="100" alt={rowData.AntidoteStatement} />;
  }

  setFilePath(event) {
    let errors = this.state.formError;
    errors.PdfFile = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            ProductUrl1: response.Source,
            uploadPdfName: response.FileName,
          });
        } else if (response.ResponseCode === "400") {
          errors.PdfFile = "Only PDF format is accepted.";
          this.setState({
            ProductUrl1: "",
          });
        }
      }
    }
  }

  setImagePath(event) {
    let errors = this.state.formError;
    errors.ProductImg = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            uploadImagPath: response.Source,
          });
        } else if (response.ResponseCode === "400") {
          errors.ProductImg = "Only image format is accepted.";
          this.setState({
            uploadImagPath: "",
          });
        }
      }
    }
  }

  setImageDescPath(event) {
    let errors = this.state.formError;
    errors.CautionarySymbol = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            uploadImagDescPath: response.Source,
          });
        } else if (response.ResponseCode === "400") {
          errors.CautionarySymbol = "Only image format is accepted.";
          this.setState({
            uploadImagDescPath: "",
          });
        }
      }
    }
  }

  setImageDescAntiPath(event) {
    let errors = this.state.formError;
    errors.AntidoteStatement = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            uploadImagDescAntiPath: response.Source,
          });
        } else if (response.ResponseCode === "400") {
          errors.AntidoteStatement = "Only image format is accepted.";
          this.setState({
            uploadImagDescAntiPath: "",
          });
        }
      }
    }
  }

  setAudioPath(event) {
    let errors = this.state.formError;
    errors.GenuineAudio = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            uploadAudioPath: response.Source,
          });
        } else if (response.ResponseCode === "400") {
          errors.GenuineAudio = "Only audio files are accepted.";
          this.setState({
            uploadAudioPath: "",
          });
        }
      }
    }
  }

  setLabel(event) {
    let errors = this.state.formError;
    errors.uploadImageLabel = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            uploadImageLabel: response.Source,
          });
        } else if (response.ResponseCode === "400") {
          errors.uploadImageLabel = "Only image format is accepted.";
          this.setState({
            uploadImageLabel: "",
          });
        }
      }
    }
  }

  setPamphlet(event) {
    let errors = this.state.formError;
    errors.uploadImagePamphlet = "";
    
    if (event.xhr && event.xhr.response) {
      const response = JSON.parse(event.xhr.response);
      if (response) {
        if (response.ResponseCode === "200") {
          this.setState({
            uploadImagePamphlet: response.Source,
          });
        } else if (response.ResponseCode === "400") {
          errors.uploadImagePamphlet = "Only image format is accepted.";
          this.setState({
            uploadImagePamphlet: "",
          });
        }
      }
    }
  }

  deleteFunc() {
    this.refs.child.confirmModal();
  }

  onErrorImage() { }
  onErrorAudio() { }

  callbackFunction = (childData) => {
    this.setState({ message: childData });
  };

  componentDidMount() {
    setTimeout(() => {
      this.GetCompany();
      this.GetCategoryDDL();
      this.GetProducts();
    }, 1000);
    
    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });
  }

  onPage(event) {
    this.setState({
      loading: true,
    });
    
    setTimeout(() => {
      this.getLazyLoadingValues(event);
      this.GetProducts();
    }, 250);
  }

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  GetCategoryDDL() {
    this.CategoryService.GetCategoryDDL().then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({
          CategoryDDL: resdata.ResponseData == null ? [] : resdata.ResponseData,
        });
      }
    });
  }

  GetSubCategoryDDL(categoryId) {
    this.CategoryService.GetSubCategoryDDL(categoryId).then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({
          SubCategoryDDL: resdata.ResponseData,
        });
      }
    });
  }

  GetCompany() {
    this.CompanyMasterService.GetCompanyDDL().then((data) => {
      const resdata = data.data;
      if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
        this.setState({
          companyDDL: resdata.ResponseData,
        });
        
        // Make company dropdown always editable
        // Only set default company for non-admin users, but still editable
        if (this.ApiService.getIsAdmin() === "false") {
          const companyId = this.ApiService.getCompanyId();
          const CompanyObj = resdata.ResponseData.filter(x => x.CompId == companyId);
          
          if (CompanyObj.length > 0) {
            this.setState({
              CompId: CompanyObj[0],
              compDisabled: false // Changed to false to make it editable
            });
          }
        } else {
          // Admin users can select any company
          this.setState({
            CompId: "", // Empty by default, user must select
            compDisabled: false // Always editable for admin
          });
        }
      }
    });
  }

  GetProducts() {
    this.tblResponse.SortColumn = "CreatedDt";
    
    // For non-admin users, add company filter
    if (this.ApiService.getIsAdmin() === "false") {
      const companyId = this.ApiService.getCompanyId();
      this.tblResponse.CompId = parseInt(companyId);
    } else {
      this.tblResponse.CompId = null; // Admin sees all companies
    }
    
    this.ProductService.GetProducts(this.tblResponse).then((data) => {
      const resdata = data.data;
      this.setState({ updateLoader: true });
      
      if (resdata !== null && resdata.ResponseData !== null && resdata.ResponseData.length > 0) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: this.tblResponse.First - 1,
          sales: this.datasource.slice(
            0,
            this.tblResponse.First - 1 + this.tblResponse.PageSize
          ),
          loading: false,
        });
      } else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          loading: false,
        });
      }
    });
  }

  validateForm1(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    
    switch (name) {
      case "WarrantyPeriodInMonth":
        if (value == null || value < 1) {
          IsValid = false;
          errors.WarrantyPeriodInMonth = "Please enter Warranty Period.";
        } else {
          errors.WarrantyPeriodInMonth = "";
          const WarrantyPeriodInMonth = value === "" ? 0 : parseInt(value);
          if (WarrantyPeriodInMonth > 0) {
            errors.WarrantyPeriodInMonth = "";
          } else {
            IsValid = false;
            errors.WarrantyPeriodInMonth = "Warranty Period should be greater than 0.";
          }
        }
        break;
    }
    
    return IsValid;
  }

  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    
    switch (name) {
      case "ProductName":
        if (value && value.trim().length < 1) {
          IsValid = false;
          errors.ProductName = "Please enter product name.";
        } else errors.ProductName = "";
        break;
        
      case "ProductCd":
        if (value && value.trim().length < 1) {
          IsValid = false;
          errors.ProductCd = "Please enter product code.";
        }
        else if (value && !value.match(/^[0-9a-zA-Z]+$/)) {
          IsValid = false;
          errors.ProductCd = "Please enter only alphanumeric.";
        }
        else errors.ProductCd = "";
        break;
        
      case "SapProductCd":
        if (value == null || (value && value.trim().length < 1)) {
          IsValid = false;
          errors.SapProductCd = "Please enter Sap Product code.";
        }
        else if (value && !value.match(/^[0-9a-zA-Z]+$/)) {
          IsValid = false;
          errors.SapProductCd = "Please enter only alphanumeric.";
        }
        else errors.SapProductCd = "";
        break;
        
      case "ProductDsrcptn":
        if (value == null || (value && value.trim().length < 1)) {
          IsValid = false;
          errors.ProductDsrcptn = "Please enter product description.";
        } else errors.ProductDsrcptn = "";
        break;
        
      case "CategoryId":
        if (value == undefined || value == '') {
          IsValid = false;
          errors.CategoryId = "Please select category.";
        } else errors.CategoryId = null;
        break;
        
      case "SubCategoryId":
        if (value == null) {
          IsValid = false;
          errors.SubCategoryId = "Please select sub category.";
        } else errors.SubCategoryId = null;
        break;
        
      case "ProductUOM":
        if (value && value.trim().length < 1) {
          IsValid = false;
          errors.ProductUOM = "Please enter product UOM.";
        } else errors.ProductUOM = "";
        break;
        
      case "ProductValue":
        if (value && value.trim().length < 1) {
          IsValid = false;
          errors.ProductValue = "Please enter product value.";
        } else if (value && !value.match(/^[0-9]+$/)) {
          IsValid = false;
          errors.ProductValue = "Please enter only number.";
          this.setState({ Qty: 0 });
        } else {
          errors.ProductValue = "";
          const ProductValue = value && value.trim() === "" ? 0 : parseInt(value.trim());
          if (ProductValue > 0) {
            errors.ProductValue = "";
          } else {
            IsValid = false;
            errors.ProductValue = "Product value should be greater than 0.";
            this.setState({ Qty: 0 });
          }
        }
        break;
        
      case "CompanyId":
        if (value == undefined || value == "" || (value && value.CompId === undefined)) {
          IsValid = false;
          errors.CompanyId = "Please select Company";
        } else {
          errors.CompanyId = "";
        }
        break;
        
      default:
        break;
    }
    
    return IsValid;
  }

  openDialog() {
    this.setState({ 
      visible: true, 
      uploadImagPath: '',
      CompId: "" // Reset company selection for new product
    });
    this.formReset();
  }

  openDialog1() {
    this.setState({ 
      visible1: true, 
      PackOF: '', 
      ProductUrl1: '',
      CompId: "" // Reset company selection for new GTIN
    });
    this.formReset();
  }

  formReset() {
    this.setState({
      ProductName: "",
      ProductCd: "",
      ProductDsrcptn: "",
      ProductImg: "",
      GTIN: "",
      PackOF: "",
      ProductUrl1: "",
      CautionarySymbol: "",
      AntidoteStatement: "",
      RegistrationNo: "",
      MarketedBy: "",
      ExpDate: "",
      ManufactureName: "",
      CustomerCareDetails: "",
      uploadImagDescPath: "",
      uploadImagDescAntiPath: "",
      GenuineAudio: "",
      ProductUOM: "",
      ProductValue: "",
      CategoryId: "",
      SapProductCd: "",
      uploadImageLabel: "",
      uploadImagePamphlet: "",
      ProductId: "",
      IsActive: true,
      TechnicalName: "",
    });
    
    let errors = this.state.formError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
    });
  }

  hideFunc() {
    this.setState({
      visible: false,
      visible1: false,
      buttonLabel: "Submit",
      formHeading: "Add Product",
    });
    this.setState({ activeIndex: 0 });
    this.setState({ prodDes: true });
    this.formReset();
  }

  hideFunc1() {
    this.setState({
      visible: false,
      visible1: false,
      buttonLabel: "Submit",
      formHeading: "Add GTIN NO",
    });
    this.setState({ activeIndex: 0 });
    this.setState({ prodDes: true });
    this.formReset();
  }

  submitDescForm(event) {
    event.preventDefault();
    let isfrmvalid = true;
    let isValidForm = true;
    let checkerror = this.state.formError;
    
    // Validate Company ID first
    const companyValid = this.validateForm(this.state.CompId, "CompanyId");
    if (!companyValid) {
      isfrmvalid = false;
      isValidForm = false;
    }
    
    Object.entries(checkerror).map(([key, value]) => {
      const val = this.state[key];
      isfrmvalid = this.validateForm(val, key);
      if (!isfrmvalid) {
        this.setState({
          checkerror: isfrmvalid
        }, () => {
          isfrmvalid = this.state.checkerror
        });
        isfrmvalid = false;
      }
    });
    
    this.saveProuduct(isValidForm);
  }

  saveProuduct(isfrmvalid) {
    if (isfrmvalid) {
      // Get company ID - if CompId is an object, extract the ID, otherwise use the value directly
      let companyId;
      if (this.state.CompId && typeof this.state.CompId === 'object') {
        companyId = this.state.CompId.CompId;
      } else if (this.state.CompId && typeof this.state.CompId === 'number') {
        companyId = this.state.CompId;
      } else {
        companyId = this.ApiService.getCompanyId();
      }
      
      allData = {
        ...allData,
        CautionarySymbol: this.state.uploadImagDescPath,
        AntidoteStatement: this.state.uploadImagDescAntiPath,
        label: this.state.uploadImageLabel,
        Pamphlet: this.state.uploadImagePamphlet,
        CompId: parseInt(companyId), // Always include company ID
      };
      
      this.setState({ updateLoader: false });
      
      setTimeout(() => {
        this.ProductService.CreateUpdateProduct(allData).then((data) => {
          const resdata = data.data;
          this.setState({ updateLoader: true });
          
          if (resdata !== null && resdata.ResponseCode === "200") {
            this.refs.Messchild.showSuccess(resdata.ResponseMessage);
            this.GetProducts();
            this.formReset();
            this.setState({
              loading: true,
              visible: false,
              visible1: false,
            });
            this.setState({ activeIndex: 0 });
            this.setState({ prodDes: true });
          } else if (resdata !== null && resdata.ResponseCode === "201") {
            this.refs.Messchild.showError(resdata.ResponseMessage);
            this.setState({
              loading: true,
              visible: false,
              visible1: false,
            });
            this.formReset();
            this.GetProducts();
            this.setState({ activeIndex: 0 });
            this.setState({ prodDes: true });
          } else if (resdata.ResponseCode === "400") {
            this.refs.Messchild.showWarn(resdata.ResponseMessage);
          } else {
            this.refs.Messchild.showError(resdata.ResponseMessage);
          }
        });
      }, 1000);
    }
  }

  submitForm(event) {
    event.preventDefault();
    let isfrmvalid = true;
    
    // Validate Company ID first
    const companyValid = this.validateForm(this.state.CompId, "CompanyId");
    if (!companyValid) {
      isfrmvalid = false;
      this.refs.Messchild.showWarn("Please select a company");
    }
    
    if (isfrmvalid) {
      // Get company ID - if CompId is an object, extract the ID, otherwise use the value directly
      let companyId;
      if (this.state.CompId && typeof this.state.CompId === 'object') {
        companyId = this.state.CompId.CompId;
      } else if (this.state.CompId && typeof this.state.CompId === 'number') {
        companyId = this.state.CompId;
      } else {
        companyId = this.ApiService.getCompanyId();
      }
      
      var formData = {
        ProductId: this.state.ProductId == "" ? 0 : parseInt(this.state.ProductId),
        ProductImg: this.state.uploadImagPath,
        PackOF: this.state.PackOF,
        ProductUrl: this.state.ProductUrl1,
        CompId: parseInt(companyId) // Always include company ID
      };
      
      allData = formData;
      
      setTimeout(() => {
        this.ProductService.CreateUpdateProduct(formData).then((data) => {
          const resdata = data.data;
          
          if (resdata !== null && resdata.ResponseCode === "200") {
            this.refs.Messchild.showSuccess(resdata.ResponseMessage);
            this.setState({
              loading: true,
              visible: false,
              visible1: false,
            });
            this.formReset();
            this.GetProducts();
          } else if (resdata.ResponseCode === "400") {
            this.refs.Messchild.showWarn(resdata.ResponseMessage);
          } else {
            this.refs.Messchild.showError(resdata.ResponseMessage);
          }
        });
      }, 100);
    }
  }

  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetProducts();
  }

  deleteProduct(productId) {
    let isValid = false;
    this.ProductService.DeleteProduct(productId).then((data) => {
      const resdata = data.data;
      
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.refs.Messchild.showSuccess(resdata.ResponseMessage);
        const totlrecord = this.state.totalRecords - 1;
        const row = this.state.rows;
        
        if (this.tblResponse.First >= totlrecord) {
          const _curntCursor = Math.round(totlrecord / row);
          this.tblResponse.First = _curntCursor + 1;
        }
        
        this.GetProducts();
        isValid = true;
      } else if (resdata.ResponseCode === "400") {
        this.refs.Messchild.showWarn(resdata.ResponseMessage);
      } else {
        this.refs.Messchild.showError(resdata.ResponseMessage);
      }
    });
    
    return isValid;
  }

  activeTemplate(rowData, column) {
    return <input type="checkbox" disabled checked={rowData.IsActive} />;
  }

  actionTemplate(rowData, column) {
    const editMode = () => {
      // Find the company object for this product
      const companyObj = this.state.companyDDL.find(x => x.CompId === rowData.CompId);
      
      this.setState({
        visible: true,
        formHeading: "Add Product Image",
        buttonLabel: "Update",
        ProductId: rowData.ProductId,
        uploadImagPath: rowData.ProductImg,
        PackOF: rowData.PackOF,
        ProductUrl1: rowData.ProductUrl,
        CompId: companyObj || { CompId: rowData.CompId, CompanyName: "" },
      });
    };

    return (
      <span>
        <Button
          type="button"
          icon="pi pi-plus"
          onClick={editMode}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
      </span>
    );
  }

  actionTemplate1(rowData, column) {
    const editAddMode = () => {
      // Find the company object from dropdown list for patching
      const companyObj = this.state.companyDDL.find(x => x.CompId === rowData.CompId);
      
      this.setState({
        visible1: true,
        formHeading: "Edit",
        buttonLabel: "Update",
        ProductId: rowData.ProductId,
        PackOF: rowData.PackOF,
        ProductUrl1: rowData.ProductUrl,
        uploadImagPath: rowData.ProductImg,
        // Patch CompId - store the full company object for the dropdown
        CompId: companyObj || { CompId: rowData.CompId, CompanyName: "" },
      });
    };
    
    return (
      <span>
        <Button
          type="button"
          icon="pi pi-pencil"
          onClick={editAddMode}
          className="p-button-warning"
          style={{ marginRight: "3px" }}
        ></Button>
      </span>
    );
  }

  onSort(event) {
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField = event.sortField;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.GetProducts();
  }

  render() {
    let header = (
      <div style={{ textAlign: "right", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {/* Refresh Button - Added on the left side */}
        <div>
          <Button
            label="Refresh from SAP"
            icon="pi pi-refresh"
            onClick={this.refreshSAPData}
            className="p-button-success"
            style={{ marginRight: "10px" }}
            loading={this.state.refreshLoading}
            disabled={this.state.refreshLoading}
          />
         
        </div>
        <div>
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText
            type="search"
            onInput={this.searchFilter}
            placeholder="Global Search"
            size="30"
          />
        </div>
      </div>
    );
    
    return (
      <>
        <MessageComponent ref="Messchild" />
        <Loaders loader={this.state.updateLoader} />
        <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
        
        <div className="heading">
          <h1>Product Master</h1>
        </div>
        
        <DataTable
          responsive={true}
          header={header}
          style={{ width: '100%' }}
          scrollable
          emptyMessage={this.state.emptyMessage}
          value={this.state.sales}
          sortMode="multiple"
          paginator={true}
          rows={this.state.rows}
          rowsPerPageOptions={[5, 10, 20]}
          totalRecords={this.state.totalRecords}
          lazy={true}
          first={this.state.first}
          onPage={this.onPage}
          onSort={this.onSort}
          className="tblAuto"
        >
          <Column field="ProductCd" header="Product Code" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="ProductName" header="Product Name" headerStyle={{ width: '100px' }} sortable={true} />
          <Column
            field="ProductImg"
            headerStyle={{ width: "120px" }}
            header="Product Image"
            body={this.brandTemplate}
          />
          <Column field="ProductUOM" header="Product UOM" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="Plant" header="Plant" headerStyle={{ width: '100px' }} sortable={true} />
          <Column field="PackOF" header="Quantity" headerStyle={{ width: '100px' }} sortable={true} />
         <Column
    field="ProductUrl"
    header="Product Url"
    headerStyle={{ width: '450px' }}
    
    body={(rowData) => (
        <a
            href={rowData.ProductUrl}
            target="_blank"
            rel="noopener noreferrer"
        >
            {rowData.ProductUrl}
        </a>
    )}
/>
          <Column field="ProductDscrptn" header="Product Description" headerStyle={{ width: '200px' }} sortable={true} />
          <Column field="Status" header="Status" headerStyle={{ width: '100px' }} sortable={true} />
          <Column body={this.actionTemplate} headerStyle={{ width: '80px' }} header="Add Product Image" />
          <Column body={this.actionTemplate1} headerStyle={{ width: '80px' }} header="Action" />
        </DataTable>
        
        {/* Dialog for Add Product Image (visible) */}
        <Dialog
          header={this.state.formHeading}
          blockScroll={true}
          visible={this.state.visible}
          className="popup-modal"
          modal={true}
          onHide={this.hideFunc}
        >
          <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
            <TabPanel header="Add Image">
              <form onSubmit={this.submitForm} style={{ overflow: "hidden" }}>
                {/* Company Dropdown - Fully Editable */}
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Company: <span style={{ color: "red" }}>*</span></label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <Dropdown
                      value={this.state.CompId}
                      options={this.state.companyDDL}
                      onChange={(e) => this.setState({ CompId: e.value })}
                      optionLabel="CompanyName"
                      placeholder="Select Company"
                      disabled={false}
                      style={{ width: "100%" }}
                    />
                    {this.state.formError.CompanyId !== "" && this.state.formError.CompanyId !== null ? (
                      <div className="error" style={{ color: "red", fontSize: "12px" }}>{this.state.formError.CompanyId}</div>
                    ) : null}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Upload Product Image:</label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <FileUpload
                      name="productfile"
                      url={process.env.REACT_APP_API_URL + "Upload/FileUpload"}
                      auto={true}
                      onUpload={this.setImagePath}
                      onError={this.onErrorImage}
                      accept="image/*"
                    />
                    
                    {this.state.uploadImagPath ? (
                      <div className="p-fileupload-row">
                        <div>
                          <img
                            alt="product"
                            role="presentation"
                            src={this.state.uploadImagPath}
                            width="50"
                          />
                        </div>
                      </div>
                    ) : null}
                    
                    {this.state.formError.ProductImg !== null ? (
                      <div className="error">
                        {this.state.formError.ProductImg}
                      </div>
                    ) : null}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Quantity:</label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <input
                      type="text"
                      value={this.state.PackOF}
                      onChange={this.handleChange1}
                      className="form-control"
                      name="PackOF"
                    />
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      {this.state.buttonLabel}
                    </button>
                  </div>
                </div>
                
                <div>
                  <label>
                    Note: Fields marked as (
                    <span style={{ color: "red" }}>*</span>) are required
                  </label>
                </div>
              </form>
            </TabPanel>
          </TabView>
        </Dialog>
        
        {/* Dialog for Edit (visible1) */}
        <Dialog
          header={this.state.formHeading}
          blockScroll={true}
          visible={this.state.visible1}
          className="popup-modal"
          modal={true}
          onHide={this.hideFunc1}
        >
          <TabView activeIndex={this.state.activeIndex} onTabChange={(e) => this.setState({ activeIndex: e.index })}>
            <TabPanel header="Edit">
              <form onSubmit={this.submitForm} style={{ overflow: "hidden" }}>
                {/* Company Dropdown - Fully Editable */}
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Company: <span style={{ color: "red" }}>*</span></label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <Dropdown
                      value={this.state.CompId}
                      options={this.state.companyDDL}
                      onChange={(e) => this.setState({ CompId: e.value })}
                      optionLabel="CompanyName"
                      placeholder="Select Company"
                      disabled={false}
                      style={{ width: "100%" }}
                    />
                    {this.state.formError.CompanyId !== "" && this.state.formError.CompanyId !== null ? (
                      <div className="error" style={{ color: "red", fontSize: "12px" }}>{this.state.formError.CompanyId}</div>
                    ) : null}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Upload PDF:</label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <FileUpload
                      name="pdfFile"
                      url={process.env.REACT_APP_API_URL + "Upload/PdfUpload"}
                      auto={true}
                      onUpload={this.setFilePath}
                      onError={this.onErrorPdf}
                      accept="application/pdf"
                      maxFileSize={30000000}
                    />
                    
                    {this.state.ProductUrl1 ? (
                      <div className="p-fileupload-row">
                        <div>
                          <embed
                            src={this.state.ProductUrl1}
                            type="application/pdf"
                            width="100%"
                            height="200px"
                          />
                        </div>
                      </div>
                    ) : null}
                    
                    {this.state.formError.ProductUrl1 !== null ? (
                      <div className="error">
                        {this.state.formError.ProductUrl}
                      </div>
                    ) : null}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-4 text-right">
                    <label>Quantity:</label>
                  </div>
                  <div className="col-md-8 mb-2">
                    <input
                      type="text"
                      value={this.state.PackOF}
                      onChange={this.handleChange1}
                      className="form-control"
                      name="PackOF"
                    />
                    
                    {this.state.formError.CustomerCareDetails !== null ? (
                      <div className="error">
                        {this.state.formError.CustomerCareDetails}
                      </div>
                    ) : null}
                  </div>
                </div>
                
                <div className="row">
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      {this.state.buttonLabel}
                    </button>
                  </div>
                </div>
                
                <div>
                  <label>
                    Note: Fields marked as (
                    <span style={{ color: "red" }}>*</span>) are required
                  </label>
                </div>
              </form>
            </TabPanel>
          </TabView>
        </Dialog>
      </>
    );
  }
}